// extracted by mini-css-extract-plugin
module.exports = {"icon":"Style_icon__1COYu","backdrop":"Style_backdrop__LREkv"};